<template>
  <div class="loan-pie-chart">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import { Chart, ArcElement, Tooltip, Legend, PieController, Title } from "chart.js";

Chart.register(ArcElement, Tooltip, Legend, PieController, Title);

const CHART_COLORS = [
  "#4e73df",
  "#1cc88a",
  "#36b9cc",
  "#f6c23e",
  "#e74a3b",
  "#858796",
  "#5a5c69",
  "#2e59d9",
  "#17a673",
  "#2c9faf"
];

export default {
  name: "LoanPieChart",
  props: {
    title: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chart: null
    };
  },
  watch: {
    items: {
      deep: true,
      handler() {
        this.renderChart();
      }
    }
  },
  mounted() {
    this.renderChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  },
  methods: {
    buildChartConfig() {
      const labels = this.items.map(item => item.label || "Unknown");
      const values = this.items.map(item => Number(item.value) || 0);

      return {
        type: "pie",
        data: {
          labels,
          datasets: [
            {
              data: values,
              backgroundColor: labels.map((_, index) => CHART_COLORS[index % CHART_COLORS.length]),
              borderWidth: 1
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: "bottom"
            },
            title: {
              display: !!this.title,
              text: this.title,
              font: {
                size: 16
              }
            }
          }
        }
      };
    },
    renderChart() {
      const canvas = this.$refs.canvas;
      if (!canvas || !this.items.length) {
        return;
      }

      if (this.chart) {
        this.chart.destroy();
        this.chart = null;
      }

      this.chart = new Chart(canvas, this.buildChartConfig());
    }
  }
};
</script>

<style scoped>
.loan-pie-chart {
  position: relative;
  height: 360px;
  width: 100%;
}
</style>
